// Port of api/fuel/app/classes/filter/search/games/filters/query/game/votes.php
export default {
	name: 'game.votes',
	priority: 41,
	require: function(config, filter) { return filter.threshold && filter.threshold.community > 0 },
	run: function(config, filter, data, query) {
		query.where('g.game_rating_count', '>=', filter.threshold.community)
	}
}
